import vueRouter from 'vue-router'
export default function createRouter() {
    return new vueRouter({
        mode: 'history', //一定要是history模式
        routes: [{
                path: "/",
                name: 'home',
                // component: resolve => require([`./views/auction/product_detail`], resolve)
                component: resolve => require([`./views/index`], resolve)
            },
           
            {
                path: '/culturalModel',
                name: 'culturalModel',
                component: resolve => require([`./views/culturalModel`], resolve) 
            },

            {
                path: '/auctionlist_bf.php',
                    name: 'auctionlistbf',
                component: resolve => require([`./views/auction/auctionbf`], resolve)
            },
            {
                path: '/auctionlist_bf.php',
                    name: 'auctionlistbf',
                component: resolve => require([`./views/auction/auctionbf`], resolve)
            },

            {
                path: '/sa',
                name: 'sa',
                component: resolve => require([`./views/sa`], resolve) 
            },
            {
                path: '/testHome',
                name: 'testHome',
                component: resolve => require([`./views/testIndex`], resolve) 
            },
            {
                path: '/preauction/pmzc',
                name: 'preview',
                component: resolve => require([`./views/preview/index`], resolve) /*拍卖预展--拍卖专场*/
            },
            {
                path: '/preauction/pmp',
                name: 'preview_product',
                component: resolve => require([`./views/preview/product`], resolve) /*拍卖预展--拍品--图文*/
            },
            {
                path: '/preauction/pmp/text',
                name: 'preview_product_text',
                component: resolve => require([`./views/preview/productText`], resolve) /*拍卖预展--拍品--文字*/
            },
            {
                path: '/preauction',
                name: 'preview_meeting',
                component: resolve => require([`./views/preview/meeting`], resolve) /*拍卖预展--拍卖会*/
            },
            {
                path: '/meeting_detail/:id',
                name: 'meeting_detail',
                component: resolve => require([`./views/auction/meeting_detail`], resolve) /*拍卖预展--拍卖会详情*/
            },
            {
                path: '/special_detail/:id',
                name: 'special_detail',
                component: resolve => require([`./views/auction/special_detail`], resolve) /*拍卖预展--专场详情*/
            },
            {
                path: '/org_detail/:id',
                name: 'org_detail',
                component: resolve => require([`./views/auction/org_detail`], resolve) /*机构详情*/
            },
            {
                path: '/paimai-:id(.*)',
                name: 'product_detail',
                component: resolve => require([`./views/auction/product_detail`], resolve) /*拍品详情*/
            },

            {
                path: '/paimai/:id',
                name: 'product_detail',
                component: resolve => require([`./views/auction/product_detail`], resolve) /*拍品详情*/
            },





            {
                path: '/result/pmzc',
                name: 'result_session',
                component: resolve => require([`./views/result/session`], resolve) /*拍卖结果--专场列表*/
            },
            {
                path: '/result',
                name: 'result_meeting',
                component: resolve => require([`./views/result/meeting`], resolve) /*拍卖结果--拍卖会*/
            },
            {
                path: '/result/pmp',
                name: 'result_product',
                component: resolve => require([`./views/result/product`], resolve) /*拍卖结果--拍品--图文*/
            },
            {
                path: '/result/pmp/text',
                name: 'result_product_text',
                component: resolve => require([`./views/result/productText`], resolve) /*拍卖结果--拍品--文字*/
            },
            {
                path: '/brand',
                name: 'brand',
                component: resolve => require([`./views/brand/index`], resolve) /*拍卖黄页*/
            },
            {
                path: '/mechanismsearch',
                name: 'mechanismsearch',
                component: resolve => require([`./views/brand/mechanismsearch`], resolve) /*拍卖黄页*/
            },
            {
                path: '/mobile/about.php',
                name: 'mobildAbout',
                component: resolve => require([`./views/mobile/about`], resolve) /*拍卖黄页*/
            },
            {
                path: '/morenews/:id',
                name: 'morenews',
                component: resolve => require([`./views/morenews/index`], resolve) /*资讯*/
            },
            {
                path: '/morenews/list:id(.*)',
                name: 'morenews',
                component: resolve => require([`./views/morenews/index`], resolve) /*资讯*/
            },
            {
                path: '/column',
                name: 'column',
                component: resolve => require([`./views/conversation/index`], resolve) /*对话*/
            },
            {
                path: '/sendInfor',
                name: 'sendInfor',
                component: resolve => require([`./views/sendInfor`], resolve) /*我要送拍*/
            },
            {
                path: '/topic',
                name: 'topic',
                component: resolve => require([`./views/conversation/topic`], resolve) /*专题*/
            },
            {
                path:'/help/introduce',
                name:'introduce',
                component: resolve => require([`./views/help/introduce`],resolve), /*官网介绍*/
            },
            {
                path:'/help/gongyue',
                name:'gongyue',
                component: resolve => require([`./views/help/gongyue`],resolve), /*中国文物艺术品拍卖企业自律公约*/
            },
            {
                path:'/empty',
                name:'empty',
                component :resolve => require([`./views/empty`], resolve) /*404*/
            },
            {
                path:'/404',
                name:'404',
                component :resolve => require([`./views/empty`], resolve) /*404*/
            },
            {
                path:'/advertisement',
                name:'advertisement',
                component :resolve => require([`./views/advertisement`], resolve) /*广告页*/
            },
            {
                path:'/bigImg',
                name:'bigImg',
                component :resolve => require([`./views/bigImg`], resolve) /*广告页*/
            },
            
            
            {
                path: '/:name',
                name: 'company',
                component: resolve => require([`./views/auctionCompany/index`], resolve), /*拍卖公司*/
                children: [
                    {
                        path: '',
                        name: 'comHome',
                        component: resolve => require([`./views/auctionCompany/views/home`],resolve), /*首页*/
                        meta: {
                            name: 'mechanism'
                        }
                    },
                    {
                        path: 'item',
                        name: 'comItem',
                        component: resolve => require([`./views/auctionCompany/views/item`],resolve), /*首页*/
                        meta: {
                            name: 'mechanism'
                        }
                    },
                    {
                        path: 'previews',
                        name: 'comPreviews',
                        component: resolve => require([`./views/auctionCompany/views/previews/index.vue`],resolve), /*拍卖预展*/
                        meta: {
                            name: 'mechanism'
                        }
                    },
                    {
                        path: 'results',
                        name: 'comResults',
                        component: resolve => require([`./views/auctionCompany/views/result`],resolve), /*拍卖结果*/
                        meta: {
                            name: 'mechanism'
                        }
                    },
                    {
                        path: 'collect',
                        name: 'comCollect',
                        component: resolve => require([`./views/auctionCompany/views/collect`],resolve), /*征集送拍*/
                        meta: {
                            name: 'mechanism'
                        }
                    },
                    {
                        path: 'news',
                        name: 'comNewsVideo',
                        component: resolve => require([`./views/auctionCompany/views/news`],resolve), /*新闻视频中心*/
                        meta: {
                            name: 'mechanism'
                        }
                    },
                    {
                        path: 'newsList',
                        name: 'comNews',
                        component: resolve => require([`./views/auctionCompany/views/news`],resolve), /*新闻中心*/
                        meta: {
                            name: 'mechanism'
                        }
                    },
                    {
                        path: 'videoList',
                        name: 'comVideo',
                        component: resolve => require([`./views/auctionCompany/views/news`],resolve), /*视频中心*/
                        meta: {
                            name: 'mechanism'
                        }
                    },
                    {
                        path: 'about',
                        name: 'comAbout',
                        component: resolve => require([`./views/auctionCompany/views/about`],resolve), /*个人中心*/
                        meta: {
                            name: 'mechanism'
                        }
                    },

                ],
            },
            {
                path: '/admin',
                name: 'admin',
                component: resolve => require([`./views/admin`], resolve),
                children:[
                    {
                        path: 'login',
                        name: 'login',
                        component: resolve => require([`./views/admin/login`], resolve),
                    },
                    {
                        path: 'adminiStrator',
                        name: 'adminiStrator',
                        component: resolve => require([`./views/admin/adminiStrator`], resolve),
                        children: [
                            {
                                path: '',
                                name: '',
                                component: resolve => require([`./views/admin/adminiStrator/pages/logo`], resolve),
                                meta:{
                                    title:'logo/形象图设置'
                                }
                            },
                            {
                                path: 'announcement',
                                name: 'announcement',
                                component: resolve => require([`./views/admin/adminiStrator/pages/announcement`], resolve),
                                meta:{
                                    title:'公告设置'
                                }
                            },
                            {
                                path: 'focusMap',
                                name: 'focusMap',
                                component: resolve => require([`./views/admin/adminiStrator/pages/focusMap`], resolve),
                                meta:{
                                    title:'焦点图设置'
                                }
                            },
                            {
                                path: 'focusMapAdd',
                                name: 'focusMapAdd',
                                component: resolve => require([`./views/admin/adminiStrator/pages/focusMapAdd`], resolve),
                                meta:{
                                    title:'焦点图设置添加图片',
                                    parent:"focusMap"
                                }
                            },
                            {
                                path: 'userServices',
                                name: 'userServices',
                                component: resolve => require([`./views/admin/adminiStrator/pages/userServices`], resolve),
                                meta:{
                                    title:'用户服务'
                                }
                            },
                            {
                                path: 'specialFeatures',
                                name: 'specialFeatures',
                                component: resolve => require([`./views/admin/adminiStrator/pages/specialFeatures`], resolve),
                                meta:{
                                    title:'特色专场'
                                }
                            },
                            {
                                path: 'specialFeaturesAdd',
                                name: 'specialFeaturesAdd',
                                component: resolve => require([`./views/admin/adminiStrator/pages/specialFeaturesAdd`], resolve),
                                meta:{
                                    title:'特色专场管理',
                                    parent:"specialFeatures"
                                }
                            },
                            {
                                path: 'previewBoutique',
                                name: 'previewBoutique',
                                component: resolve => require([`./views/admin/adminiStrator/pages/previewBoutique`], resolve),
                                meta:{
                                    title:'预展精品'
                                }
                            },
                            {
                                path: 'previewBoutiqueAdd',
                                name: 'previewBoutiqueAdd',
                                component: resolve => require([`./views/admin/adminiStrator/pages/previewBoutiqueAdd`], resolve),
                                meta:{
                                    title:'预展精品添加',
                                    parent:"previewBoutique"
                                }
                            },
                            {
                                path: 'transactionBoutique',
                                name: 'transactionBoutique',
                                component: resolve => require([`./views/admin/adminiStrator/pages/transactionBoutique`], resolve),
                                meta:{
                                    title:'成交精品'
                                }
                            },
                            {
                                path: 'transactionBoutiqueAdd',
                                name: 'transactionBoutiqueAdd',
                                component: resolve => require([`./views/admin/adminiStrator/pages/transactionBoutiqueAdd`], resolve),
                                meta:{
                                    title:'成交精品添加',
                                    parent:"transactionBoutique"
                                }
                            },
                            {
                                path: 'specialManagement',
                                name: 'specialManagement',
                                component: resolve => require([`./views/admin/adminiStrator/pages/specialManagement`], resolve),
                                meta:{
                                    title:'专场管理'
                                }
                            },
                            {
                                path: 'collectionManagement',
                                name: 'collectionManagement',
                                component: resolve => require([`./views/admin/adminiStrator/pages/collectionManagement`], resolve),
                                meta:{
                                    title:'征集管理'
                                }
                            },
                            {
                                path: 'collectionManagementAdd',
                                name: 'collectionManagementAdd',
                                component: resolve => require([`./views/admin/adminiStrator/pages/collectionManagementAdd`], resolve),
                                meta:{
                                    title:'发布征集',
                                    parent:"collectionManagement"
                                }
                            },
                            {
                                path: 'shootingManagement',
                                name: 'shootingManagement',
                                component: resolve => require([`./views/admin/adminiStrator/pages/shootingManagement`], resolve),
                                meta:{
                                    title:'送拍管理'
                                }
                            },
                            {
                                path: 'shootingManagementAdd',
                                name: 'shootingManagementAdd',
                                component: resolve => require([`./views/admin/adminiStrator/pages/shootingManagementAdd`], resolve),
                                meta:{
                                    title:'添加拍品',
                                    parent:"shootingManagement"
                                }
                            },
                            {
                                path: 'companyProfile',
                                name: 'companyProfile',
                                component: resolve => require([`./views/admin/adminiStrator/pages/companyProfile`], resolve),
                                meta:{
                                    title:'公司简介'
                                }
                            },
                            {
                                path: 'contactPage',
                                name: 'contactPage',
                                component: resolve => require([`./views/admin/adminiStrator/pages/contactPage`], resolve),
                                meta:{
                                    title:'联系方式'
                                }
                            },
                            {
                                path: 'physicalStoreDisplay',
                                name: 'physicalStoreDisplay',
                                component: resolve => require([`./views/admin/adminiStrator/pages/physicalStoreDisplay`], resolve),
                                meta:{
                                    title:'实体店展示'
                                }
                            },{
                                path: 'physicalStoreDisplayAdd',
                                name: 'physicalStoreDisplayAdd',
                                component: resolve => require([`./views/admin/adminiStrator/pages/physicalStoreDisplayAdd`], resolve),
                                meta:{
                                    title:'新增实体店',
                                    parent:"physicalStoreDisplay"
                                }
                            },
                            {
                                path: 'institutionalFramework',
                                name: 'institutionalFramework',
                                component: resolve => require([`./views/admin/adminiStrator/pages/institutionalFramework`], resolve),
                                meta:{
                                    title:'组织机构'
                                }
                            },
                            {
                                path: 'branchOffice',
                                name: 'branchOffice',
                                component: resolve => require([`./views/admin/adminiStrator/pages/branchOffice`], resolve),
                                meta:{
                                    title:'办事处/分公司'
                                }
                            },
                            {
                                path: 'consultingFeedback',
                                name: 'consultingFeedback',
                                component: resolve => require([`./views/admin/adminiStrator/pages/consultingFeedback`], resolve),
                                meta:{
                                    title:'咨询反馈'
                                }
                            },
                            {
                                path: 'displaySettings',
                                name: 'displaySettings',
                                component: resolve => require([`./views/admin/adminiStrator/pages/displaySettings`], resolve),
                                meta:{
                                    title:'显示设置'
                                }
                            },
                           
                            
                        ]
                    }
                ]
            },
            {
                path: '/:specialId/:meetingid?/:sendInforId?',
                name: 'idHome',
                component: resolve => require([`./views/index`], resolve) 
            },
            {
                path:'*',
                redirect:'/'
            },
            {
                path:'/metrics',
                name:'metrics',
                component :resolve => require([`./views/404`], resolve) /*404*/
            },
            
        ]
    })
}